import { PortableText, PortableTextReactComponents } from '@portabletext/react'
import Link from '@/components/Link/Link'

const portableTextSerializer: Partial<PortableTextReactComponents> = {
  marks: {
    link: ({ value, text }) => (
      <Link
        link={{
          ...value,
          label: text,
        }}
      />
    ),
  },
}

function BlogPostRichText({ content }: SanityContentBlockProps) {
  return (
    <PortableText
      value={content}
      components={portableTextSerializer}
      onMissingComponent={false}
    />
  )
}

export default BlogPostRichText
